// action
import {
    SAVE_MODULE,
    SAVE_MODULE_FAIL,
    SAVE_MODULE_SUCCESS,
    SAVE_MODULE_RESET
} from '../action/saveModuleAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_MODULE:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_MODULE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_MODULE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_MODULE_RESET:
            return initialState
        default:
            return state
    }
}